import { render, staticRenderFns } from "./ConfigurationFormDialog.vue?vue&type=template&id=2dfd0b94&scoped=true&"
import script from "./ConfigurationFormDialog.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationFormDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationFormDialog.vue?vue&type=style&index=0&id=2dfd0b94&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd0b94",
  null
  
)

export default component.exports